import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { AuthService } from '@tablesready/frontend-auth';

@Injectable({ providedIn: 'root' })
export class IsAuthorizedUserGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.isAuthenticated()) {
      let navigatePath = '/';

      if (route.queryParams.verify === 'success') {
        navigatePath = '/waitlist?verify=success';
      }

      this.router.navigateByUrl(navigatePath);
      return false;
    }

    return true;
  }
}
